// Documentos da Biofix; cada rota passa o seu em `variant` (padrão: comunicado de tratamento)
export const DOCUMENTS = {
  communication: 'communication',
  guide: 'guide',
  notice: 'notice',
  authorization: 'authorization',
  certificate: 'certificate',
  gasFree: 'gasFree',
  photoReport: 'photoReport'
}

export const TITLES = {
  [DOCUMENTS.communication]: 'Comunicado de Tratamento Fitossanitário',
  [DOCUMENTS.guide]: 'Guia de Aplicação - Fosfina',
  [DOCUMENTS.notice]: 'Notificação de Fumigação',
  [DOCUMENTS.authorization]: 'Carta de Autorização',
  [DOCUMENTS.certificate]: 'Certificado de Fumigação',
  [DOCUMENTS.gasFree]: 'Certificado de Expurgo e Exaustão de Gases',
  [DOCUMENTS.photoReport]: 'Relatório Fotográfico'
}
